const attachThreadMutationStatus = (responseShape = {}) => {
  const payload = responseShape?.data;

  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return responseShape;
  }

  return {
    ...responseShape,
    data: {
      ...payload,
      status: responseShape?.status ?? null
    }
  };
};

export default attachThreadMutationStatus;
